import React, { useContext, useState, useEffect } from 'react'
import Form, { Select } from '#Form'
import Dialog from '#Dialog'

import APICtx from '#api'

const ODLPhaseAggrForm = ({ _id, resource }) => {
	const api = useContext(APICtx)
	const [ phasesOpts, setPhasesOpts ] = useState([])

	useEffect(() => {
		_id && api.call('ops/job/aggregation/options', { _id, resourceId:resource })
			.then(setPhasesOpts)
	}, [ _id ])

	const formDef = {
		_id,
		callSet: "ops/job/aggregation/set",
	}

	return (
		<Form {...formDef}>
			<Select label="Lavorazione principale" name="parentId" options={phasesOpts} emptyLabel="-- selezionare il lavoro a cui aggregare --" />
		</Form>
	)
}

const ODLPhaseAggrDialog = ({ _id, handleClose, handleRefresh, handleRowRefresh, resource }) => {
	const triggerClose = () => {
		handleClose()
		handleRowRefresh?.()
		handleRefresh?.()
	}

	const open = Boolean(_id)
	const title = 'Aggrega ad altro ODL'
	return (
		<Dialog
			handleClose={triggerClose}
			open={open}
			title={title}
			width="md"
		>
			<ODLPhaseAggrForm _id={_id} resource={resource} />
		</Dialog>
	)
}
export default ODLPhaseAggrDialog
